import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import React, { useState } from "react";

interface Column {
  id: "proprietarioQR" | "ora" | "fila" | "posto";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: "proprietarioQR", label: "Proprietario QR", minWidth: 100 },
  {
    id: "ora",
    label: "Ora",
    minWidth: 100,
    align: "right",
  },
  {
    id: "fila",
    label: "Fila",
    minWidth: 100,
    align: "right",
  },
  {
    id: "posto",
    label: "Posto",
    minWidth: 100,
    align: "right",
  },
];

interface Occupante {
  nome: string;
  cognome: string;
  numero: number;
  codicefiscale: string;
}

interface ReservationActivity {
  proprietarioQR: string;
  ora: number;
  fila: number;
  posto: number;
  occupanti: Occupante[];
}

const reservationActivities: ReservationActivity[] = [
  {
    proprietarioQR: "Feel Empty",
    ora: 1200,
    fila: 14,
    posto: 88,
    occupanti: [
      {
        nome: "Danielo",
        cognome: "Irsuti",
        numero: 1111111111,
        codicefiscale: "DNLLRST",
      },
      {
        nome: "Danielo",
        cognome: "Firesuti",
        numero: 2222222222,
        codicefiscale: "DNLFRST",
      },
    ],
  },
  {
    proprietarioQR: "Faster Ino",
    ora: 1230,
    fila: 18,
    posto: 89,
    occupanti: [
      {
        nome: "Milo",
        cognome: "Purssuti",
        numero: 3333333333,
        codicefiscale: "MLLPRST",
      },
      {
        nome: "Danielo",
        cognome: "Firesuti",
        numero: 2222222222,
        codicefiscale: "DNLFRST",
      },
      {
        nome: "Danielooh",
        cognome: "Feelsuti",
        numero: 4444444444,
        codicefiscale: "DNLFLST",
      },
    ],
  },
  {
    proprietarioQR: "Kay Ino",
    ora: 1300,
    fila: 19,
    posto: 90,
    occupanti: [
      {
        nome: "N-no",
        cognome: "N-no",
        numero: 5555555555,
        codicefiscale: "N-N-N-N",
      },
      {
        nome: "S-si",
        cognome: "S-si",
        numero: 66666666666,
        codicefiscale: "S-S-S-S",
      },
      {
        nome: "Nooo",
        cognome: "Nooo",
        numero: 7777777777,
        codicefiscale: "NNNNNNN",
      },
      {
        nome: "Siii",
        cognome: "Siii",
        numero: 8888888888,
        codicefiscale: "SSSSSSS",
      },
    ],
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  addButton: {
    marginTop: 20,
  },
  rootRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F5F5F5",
    },
  },
});

function createData(
  proprietarioQR: string,
  ora: number,
  fila: number,
  posto: number,
  occupanti: Occupante[]
) {
  return {
    proprietarioQR,
    ora,
    fila,
    posto,
    occupanti,
  };
}

function Row(props: { row: ReturnType<typeof createData> }) {
  const { row } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.proprietarioQR}
        </TableCell>
        <TableCell align="right">{row.ora}</TableCell>
        <TableCell align="right">{row.fila}</TableCell>
        <TableCell align="right">{row.posto}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={3}>
              <Typography variant="h6" gutterBottom component="div">
                Occupanti
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell>Cognome</TableCell>
                    <TableCell>Numero di telefono</TableCell>
                    <TableCell>Codice Fiscale</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.occupanti.map((occupantiRow) => (
                    <TableRow
                      className={classes.rootRow}
                      key={occupantiRow.nome}
                    >
                      <TableCell component="th" scope="row">
                        {occupantiRow.nome}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {occupantiRow.cognome}
                      </TableCell>
                      <TableCell>{occupantiRow.numero}</TableCell>
                      <TableCell>{occupantiRow.codicefiscale}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const rows = reservationActivities;

const TableReservationActivities: React.FC = () => {
  /*  const holders = useSelector(holderSelectors.getAllHolders); //MOCKATO PER PAGINAZIONE
  const dispatch = useDispatch(); */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const maxPage = Number(reservationActivities.length);

  const handleChangePage = (event: unknown, newPage: number) => {
    /*  if (newPage > page) {
      dispatch(
        loadAllHolders({
          start_after:
            holders.data?.results[holders.data?.results.length - 1].uid,
          sort_by: [{ field: "uid", order: SortDirection.ASC }],
        })
      );
    } else {
      dispatch(
        loadAllHolders({
          end_before:
            holders.data?.results[holders.data?.results.length - 1].uid,
          sort_by: [{ field: "uid", order: SortDirection.ASC }],
        })
      );
    }
    setPage(0);
    setPage(newPage); */
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  if (!reservationActivities || reservationActivities.length === 0) return null;

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <Row key={row.proprietarioQR} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={maxPage}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="N. elementi"
      />
    </>
  );
};

export default TableReservationActivities;
